import { createSlice } from "@reduxjs/toolkit";
import {
  getFavorite,
  getsessionFavoritePost,
  getDesFavorite,
} from "../actions/fluxoNSimilar";

interface FavoriteState {
  sessionFavorite: any | null;
  sessionFavoritePost: any | null;
  sessionDesFavorite: any | null;
  status: "idle" | "loading" | "ready" | "error";
  error: unknown | null;
  httpStatus: number | null;
  messageStatus: any;
}

const initialState: FavoriteState = {
  sessionFavorite: null,
  sessionFavoritePost: null,
  sessionDesFavorite: null,
  status: "idle",
  error: null,
  httpStatus: null,
  messageStatus: null,
};
const sessionFavoriteSlice = createSlice({
  name: "sessionFavorite",
  initialState,
  reducers: {
    resetClear(state) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFavorite.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getFavorite.rejected, (state, action) => {
        state.status = "error";
        state.sessionFavorite = null;
        state.error = action.payload;
        state.httpStatus = action.payload?.httpStatus || null;
        state.messageStatus = action.error.message;
      })
      .addCase(getFavorite.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionFavorite = action.payload.message;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(getsessionFavoritePost.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getsessionFavoritePost.rejected, (state, action) => {
        state.status = "error";
        state.sessionFavoritePost = null;
        state.error = action.payload;
        state.httpStatus = action.payload?.httpStatus || null;
        state.messageStatus = action.error.message;
      })
      .addCase(getsessionFavoritePost.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionFavoritePost = action.payload.message;
        state.error = null;
        state.httpStatus = 200;
      })

      .addCase(getDesFavorite.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getDesFavorite.rejected, (state, action) => {
        state.status = "error";
        state.sessionDesFavorite = null;
        state.error = action.payload?.message;
        state.httpStatus = action.payload?.httpStatus || null;
        state.messageStatus = action.error.message;
      })
      .addCase(getDesFavorite.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionDesFavorite = action.payload;
        state.error = null;
        state.httpStatus = 200;
      });
  },
});

export const { resetClear } = sessionFavoriteSlice.actions;
export default sessionFavoriteSlice.reducer;
